import { Handle, Position } from '@xyflow/react';
import { Headset } from 'lucide-react';

import { cn } from '@/lib/utils';

import { AGENT_NODE_COLORS } from '../agent-graph-utils';

import type { AgentNode } from '@repo/shared-types';

const colors = AGENT_NODE_COLORS.human;
const handleClass = '!h-2 !w-2 !border !border-white dark:!border-neutral-900';

export const HumanNode = ({ data, selected }: { data: AgentNode; selected?: boolean }) => {
  const subtitle = data.transfer_target_key ? `→ ${data.transfer_target_key}` : 'no target';

  return (
    <div className="flex w-[92px] flex-col items-center">
      <div
        className={cn(
          'bg-card relative flex h-14 w-14 items-center justify-center rounded-xl border shadow-sm transition-all',
          'hover:shadow-md',
          selected ? 'border-primary ring-primary/30 ring-2' : 'border-border',
        )}
      >
        <Handle type="target" position={Position.Top} className={cn(handleClass, colors.handle)} />

        <div
          className={cn(
            'flex h-8 w-8 items-center justify-center rounded-lg',
            colors.tint,
            colors.icon,
          )}
        >
          <Headset size={16} />
        </div>
      </div>

      <p className="text-foreground mt-1.5 max-w-full truncate text-[10px] leading-tight font-medium">
        {data.name || 'Unnamed'}
      </p>
      <p className="text-muted-foreground max-w-full truncate text-[9px] leading-tight">
        {subtitle}
      </p>
    </div>
  );
};
